import { MarketplaceDefaults } from './interfaces';

export const MARKETPLACE_DEFAULTS: MarketplaceDefaults = {
    // NA marketplaces
    A2Q3Y263D00KWC: {
        name: 'BR'
    },
    AZXD3QD5B39HD: {
        name: 'BR_DEVO'
    },
    A2EUQ1WTGCTBG2: {
        name: 'CA'
    },
    A2WDZJZ5TCRMLH: {
        name: 'CL'
    },
    A2IDBVIE7EAGN4: {
        name: 'CL_DEVO'
    },
    A1ZXRLSQW2V54D: {
        name: 'CO'
    },
    A1NOHO22DE3OHQ: {
        name: 'CO_DEVO'
    },
    A1AM78C64UM0Y8: {
        name: 'MX'
    },
    A3P3J5A7D2ZVXI: {
        name: 'MX_DEVO'
    },
    ATVPDKIKX0DER: {
        name: 'US'
    },

    AGWSWK15IEJJ7: {
        name: 'PYOP_US_PROD'
    },
    A3BXB0YN3XH17H: {
        name: 'PYOP_US_PROD_SANDBOX'
    },
    A35A4JO734ER04: {
        name: 'PYOP_US_DEVO'
    },
    A341L3VCFKNMIY: {
        name: 'PYOP_US_DEVO_SANDBOX'
    },
    A2CE4MDCUAASDP: {
        name: 'PYOP_CA_PROD'
    },
    A2VJI655WT2I0B: {
        name: 'PYOP_CA_PROD_SANDBOX'
    },
    A1NWP2E4EKQP94: {
        name: 'PYOP_CA_DEVO'
    },
    ASBG27DKM7EX6: {
        name: 'PYOP_CA_DEVO_SANDBOX'
    },

    // EU marketplaces
    A2VIGQ35RCS4UG: {
        name: 'AE'
    },
    A34GYYCZVDBSIK: {
        name: 'AE_DEVO'
    },
    A1PA6795UKMFR9: {
        name: 'DE'
    },
    AMEN7PMS3EDWL: {
        name: 'BE'
    },
    A1YFOMBPFBRY22: {
        name: 'BE_DEVO'
    },
    ARBP9OOSHTCHU: {
        name: 'EG'
    },
    AUJPM9XGFJRC7: {
        name: 'EG_DEVO'
    },
    A1RKKUPIHCS9HS: {
        name: 'ES'
    },
    AJZF8LZ1EJVJN: {
        name: 'ES_DEVO'
    },
    A13V1IB3VIYZZH: {
        name: 'FR'
    },
    A1F83G8C2ARO7P: {
        name: 'GB'
    },
    APJ6JRA9NG5V4: {
        name: 'IT'
    },
    A3HOBANJMCMD83: {
        name: 'IT_DEVO'
    },
    A28R8C7NBKEWEA: {
        name: 'IE'
    },
    AQGJ466SKA0F0: {
        name: 'IE_DEVO'
    },
    A21TJRUUN4KGV: {
        name: 'IN'
    },
    A2XZLSVIQ0F4JT: {
        name: 'IN_DEVO'
    },
    A3OCL2LJ6GDH9T: {
        name: 'NG'
    },
    A3PJZM0QIA8QDU: {
        name: 'NG_DEVO'
    },
    A1805IZSGTT6HS: {
        name: 'NL'
    },
    A1M3WC0SJ3A38T: {
        name: 'NL_DEVO'
    },
    A1C3SOZRARQ6R3: {
        name: 'PL'
    },
    AKY4K4WKH21YQ: {
        name: 'PL_DEVO'
    },
    A17E79C6D8DWNP: {
        name: 'SA'
    },
    A1MQPSGJ6U9Q54: {
        name: 'SA_DEVO'
    },
    A2NODRKZP88ZB9: {
        name: 'SE'
    },
    AT614YYYNOC1S: {
        name: 'SE_DEVO'
    },
    A33AVAJ2PDY3EV: {
        name: 'TR'
    },
    A3CQBQD3RGPJR8: {
        name: 'TR_DEVO'
    },
    AE08WJ6YKNBMC: {
        name: 'ZA'
    },
    A3TFQ1G9L8TQ5L: {
        name: 'ZA_DEVO'
    },

    AZAJMM36N6WQL: {
        name: 'PYOP_UK_PROD'
    },
    A3M3RRFO9XDT2G: {
        name: 'PYOP_UK_PROD_SANDBOX'
    },
    A2UWQKHEFGNQY3: {
        name: 'PYOP_UK_DEVO'
    },
    A2V84NPDZD3ZEH: {
        name: 'PYOP_UK_DEVO_SANDBOX'
    },
    A53RDEWN57UU5: {
        name: 'PYOP_DE_PROD'
    },
    A1G8446IYHA4MR: {
        name: 'PYOP_DE_PROD_SANDBOX'
    },
    A34RX6LWLXD2KA: {
        name: 'PYOP_DE_DEVO'
    },
    A225AO9WA6YYOF: {
        name: 'PYOP_DE_DEVO_SANDBOX'
    },
    A3FDG49KKM823Y: {
        name: 'PYOP_IN_PROD'
    },
    A1IAUC0NN979H6: {
        name: 'PYOP_IN_PROD_SANDBOX'
    },
    A18VPDB9UTK24D: {
        name: 'PYOP_IN_DEVO'
    },
    A16Z2XWZJTFS70: {
        name: 'PYOP_IN_DEVO_SANDBOX'
    },

    // FE marketplaces
    A39IBJ37TRP1C6: {
        name: 'AU'
    },
    A1RNPCQ4K8U27I: {
        name: 'AU_DEVO'
    },
    A1VC38T7YXB528: {
        name: 'JP'
    },
    AD2EMQ3L3PG8S: {
        name: 'RU'
    },
    A38NPJYVS5YHNH: {
        name: 'RU_DEVO'
    },
    A19VAU5U5O7RUS: {
        name: 'SG'
    },
    A1DQ6JV7I20JSG: {
        name: 'SG_DEVO'
    },

    A75P1MG8VMU51: {
        name: 'PYOP_JP_PROD'
    },
    A31YDYE76E6TCP: {
        name: 'PYOP_JP_PROD_SANDBOX'
    },
    A2EFPHRCZ60KI3: {
        name: 'PYOP_JP_DEVO'
    },
    A1U1OSY46WLA42: {
        name: 'PYOP_JP_DEVO_SANDBOX'
    },

    // CN Marketplaces
    AAHKV2X7AFYLW: {
        name: 'CN'
    }
};
